import { render, staticRenderFns } from "./PremiumContentsToggle.vue?vue&type=template&id=6b7e6bc7&"
import script from "./PremiumContentsToggle.vue?vue&type=script&lang=js&"
export * from "./PremiumContentsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports